import styled from 'styled-components';

export const Container = styled.div`
  min-height: 600px;

  .report-style-class {
    height: 600px;
  }
`;
